import { AbstractControl, ValidatorFn } from "@angular/forms";

export const notEmpty = (): ValidatorFn => (control: AbstractControl): { [key: string]: boolean } | null => {
  const value = control.value;
  if (value && value.trim().length === 0) return { notOnlySpaces: true };

  return null;
};
